import { createQueryKeys } from '@lukemorales/query-key-factory';

import API from '../../index';
import {
  GetCampaignPaymentsGroupedByCampaignRequestParams,
} from './campaignPayments.types';

export const CAMPAIGN_PAYMENT_DTO_ENUMS = {
  TYPE: {
    SINGLE: 'SINGLE',
    MONTHLY: 'MONTHLY',
    CANCEL: 'CANCEL',
    COMMISSION: 'COMMISSION',
    YEARLY: 'YEARLY',
    INSPECTION_FEE: 'INSPECTION_FEE',
    VIDEO_CLEAN: 'VIDEO_CLEAN',
    COMMISSION_INCREASE: 'COMMISSION_INCREASE',
    REFUND_FULL: 'REFUND_FULL',
    REFUND_PARTIAL: 'REFUND_PARTIAL',
    REFUND_SINGLE: 'REFUND_SINGLE',
    REFUND_COMMISSION: 'REFUND_COMMISSION',
    REFUND_COMMISSION_INCREASE: 'REFUND_COMMISSION_INCREASE',
    REFUND_INSPECTION_FEE: 'REFUND_INSPECTION_FEE',
  },
  TYPE_CD: {
    SINGLE: 1,
    MONTHLY: 2,
    CANCEL: 3,
    COMMISSION: 4,
    YEARLY: 5,
    INSPECTION_FEE: 6,
    VIDEO_CLEAN: 7,
    COMMISSION_INCREASE: 8,
    REFUND_FULL: 9,
    REFUND_PARTIAL: 10,
    REFUND_SINGLE: 11,
    REFUND_COMMISSION: 12,
    REFUND_COMMISSION_INCREASE: 13,
    REFUND_INSPECTION_FEE: 14,
  },
  BILLING_TYPE: {
    FREE: 'FREE',
    PAID: 'PAID',
  },
  PAYMENT_GATEWAY_PROVIDER: {
    STRIPE: 'STRIPE',
    INNOPAY: 'INNOPAY',
    GMO: 'GMO',
  },
  PAYMENT_GATEWAY_PROVIDER_CD: {
    STRIPE: 1,
    INNOPAY: 2,
    GMO: 3,
  },
} as const;

export const campaignPaymentsQueryKeys = createQueryKeys('campaignPayments', {
  getCampaignPaymentsByCampaign: (params: GetCampaignPaymentsGroupedByCampaignRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.CampaignPayments.indexGroupedByCampaign(params),
  }),
});
